var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.104 21.144V30h5.145l-.004-11.427a5.146 5.146 0 0 0-5.142-5.141H13.71a2.57 2.57 0 0 1-2.568-2.571V2.003H6v11.43a5.143 5.143 0 0 0 5.142 5.141h7.396a2.57 2.57 0 0 1 2.566 2.571zM11.321 30l-.002-3.494a5.14 5.14 0 0 0-5.142-5.142V30h5.145zM26.07 2h-5.142V5.5a5.14 5.14 0 0 0 5.142 5.14V2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHusd);
export default __webpack_public_path__ + "static/media/HUSD.4b9eee8bda97ba6583e0279bd2b21a05.svg";
export { ForwardRef as ReactComponent };